module.exports = __webpack_public_path__ + "img/TiNPad-方形-Inpillar-圆形.73a7006e.svg";